import { createRecipeFromModel } from '@akin-home/recipes-front-end';
import { useMutation, useQueryClient } from 'react-query';
import { recipesQueryKey } from './query_key';

export const useCreateRecipe = () => {
  const client = useQueryClient();

  return useMutation(createRecipeFromModel, {
    onSuccess(data) {
      client.invalidateQueries(recipesQueryKey.lists());
      client.invalidateQueries(recipesQueryKey.all_pages());
    },
  });
};
